import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { motion } from 'framer-motion';
import { IMainBottomMenuMobile } from '@modules/header/domain/models/menu.model';
import Overlay from '@components/layouts/overlay/Overlay';
import { analytics } from '@shared/utils/segment.utils';
import MenuTitleMobileLogic from '../menuTitle/MenuTitleMobile.logic';
import { itemListAnimation, listContainerAnimation, mainContainerAnimation, overlayAnimation, wrapperContainerAnimation } from './MainMenuMobile.animate';
import { CloseIcon, Divider, ListContainerAnimation, MainContainer, MainMenuList, MenuTitle, OptionMenu, WrapperBottomMenu, WrapperDivier, WrapperFixedHeight, WrapperMenuLink } from './MainMenuMobile.style';
interface Props {
  bottomMenuList: IMainBottomMenuMobile[];
  optionMenuList: IMainBottomMenuMobile[];
  isMenuOpen: boolean;
  setIsOpen: (val: boolean) => void;
}
const MainMenuMobile: FC<Props> = ({
  bottomMenuList,
  optionMenuList,
  setIsOpen,
  isMenuOpen
}: Props) => {
  const router = useRouter();
  const pagePath = router.pathname;
  const onCloseMenu = () => {
    setIsOpen(false);
  };
  const onClickBottomMenu = (menu: IMainBottomMenuMobile) => {
    setIsOpen(false);
    analytics.track('Hamburger Menu Click Menu', {
      event: 'Hamburger Menu Click Menu',
      menu: menu.title
    });
  };
  return <>
            <MainContainer initial={false} variants={mainContainerAnimation} animate={isMenuOpen ? 'open' : 'closed'}>
                <WrapperFixedHeight>
                    <motion.div variants={wrapperContainerAnimation}>
                        <ListContainerAnimation variants={listContainerAnimation}>
                            <MainMenuList variants={itemListAnimation}>
                                <MenuTitle>เมนูหลัก</MenuTitle>
                                <CloseIcon src="/icons/x.svg" alt="close" onClick={onCloseMenu} width={18} height={36} />
                            </MainMenuList>

                            <MenuTitleMobileLogic />

                            <WrapperDivier variants={itemListAnimation}>
                                <Divider />
                            </WrapperDivier>

                            <WrapperBottomMenu variants={itemListAnimation}>
                                {bottomMenuList.map((list, index) => <WrapperMenuLink key={index}>
                                        <Link onClick={() => onClickBottomMenu(list)} href={list.linkOut} target={list.isLinkOut ? '__blank' : ''} className={`${pagePath === list.linkOut ? 'active' : ''}`}>
                                            {list.title}
                                        </Link>
                                    </WrapperMenuLink>)}

                                {optionMenuList.map((menu, index) => <OptionMenu key={index} href={menu.linkOut} target={menu.isLinkOut ? '__blank' : ''} onClick={() => onClickBottomMenu(menu)}>
                                        <span>•</span> {menu.title}
                                    </OptionMenu>)}
                            </WrapperBottomMenu>
                        </ListContainerAnimation>
                    </motion.div>
                </WrapperFixedHeight>
            </MainContainer>

            {isMenuOpen && <motion.div variants={overlayAnimation} animate={isMenuOpen ? 'open' : 'closed'} onClick={onCloseMenu}>
                    <Overlay />
                </motion.div>}
        </>;
};
export default MainMenuMobile;